import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const ListIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <line x1="9" y1="6" x2="20" y2="6" />
    <line x1="9" y1="12" x2="20" y2="12" />
    <line x1="9" y1="18" x2="20" y2="18" />
    <circle cx="4.5" cy="6" r="0.8" />
    <circle cx="4.5" cy="12" r="0.8" />
    <circle cx="4.5" cy="18" r="0.8" />
  </svg>
);

export default ListIcon;
